import React, { Component } from 'react';
import VideoModal from '../pieces/VideoModal';

class Video extends Component {
  state = {
    selectedVideo: {},
    viewVideo: false
  }
  componentDidMount(){
    this.props.getVideos();

  }
  handleClose = (e) => {
    e.preventDefault();
    this.setState({
      viewVideo: false
    })
  }
  handleClick = (e) => {
    e.preventDefault();
    console.log(e.currentTarget.href);
    let obj = {};
    for (let value of this.props.videos){
      if(e.currentTarget.href === value.link){
        obj = value;
      }
    }
    this.setState({
      selectedVideo: obj, 
      viewVideo: true
    })
  }
  handleImageLoaded = (e) => {
    e.currentTarget.classList.add('loaded');
  }
  render(){

    return(
      <div className="general-content photos-content">
        {this.state.viewVideo && 
          <VideoModal
            view={this.state.viewVideo}
            video={this.state.selectedVideo}
            handleClose={this.handleClose}
          />
        }
        
        <h2 className="content-headline no-margin">Video</h2>
        
        <div className="row images">
          {this.props.videos.map((val, idx) => (
            <div key={idx} className={`medium-6 columns img-wrapper ${idx === this.props.videos.length -1 && 'end'}`}>
              <a onClick={this.handleClick} href={val.link}>
                <i className="fa fa-youtube-play fa-3x" aria-hidden="true"></i>
                <img 
                  src={`assets/img/video/${val.thumb}.jpg`}
                  onLoad={this.handleImageLoaded}
                  />
              </a>
              <div className="caption">{val.title}</div>
            </div>

          ))}
          

          
        </div>
        

      </div>
    );
  }
}
export default Video;


// WEBPACK FOOTER //
// ./src/modules/pages/Video.js